<template>
  <v-container id="ur-list">
    <sala-municipio-header :payload="payload"> </sala-municipio-header>

    <v-row>
      <v-col
        ><h3><b>Cargos e Serviços</b></h3></v-col
      >
      <v-col class="text-right">
        <v-btn
          outlined
          color="primary"
          class="ml-3"
          :to="'/sala-principal/novo/' + cityId"
        >
          Cadastrar
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.nomeCargo="{ item }">
            <a
              :href="'./#/sala-principal/editar/' + item.cargosFuncoesId"
              v-if="!isAnalista || item.grupoId === 2"
              >{{ item.nomeCargo }}</a
            >
            <span v-else>{{ item.nomeCargo }}</span>
          </template>

          <template v-slot:item.acoes_delete="{ item }">
            <v-row>
              <v-col cols="1">
                <app-modal-delete
                  v-if="isAdmin"
                  :object="item"
                  @on-save="loadSalaUnidade"
                >
                  <template v-slot:title> Exclusão de cargo </template>
                </app-modal-delete>
              </v-col>

              <v-col cols="1"> </v-col>
            </v-row>
          </template>

          <template slot="no-data">
            <span> Nenhum dado encontrado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { cargosFuncoes } from "../API/cargosFuncoesApi";
import { mapActions, mapGetters } from "vuex";
import AppModalDelete from "./../components/ModalDelete";
import SalaMunicipioHeader from "../../sala-principal/components/SalaMunicipioHeader";

export default {
  components: {
    AppModalDelete,
    SalaMunicipioHeader,
  },
  data() {
    return {
      headers: [
        { text: "Cargo", value: "nomeCargo" },
        { text: "Órgão", value: "orgao" },
        { text: "Ocupantes atuais", value: "nomeOcupantes" },
        { text: "Missão estratégica", value: "missao" },
        { text: "Serviços Executados", value: "servicosExecutados" },
        { text: "Servicos Não Executados", value: "servicosNaoExecutados" },
        {
          text: "Nº de pessoal INTERNO disponível",
          value: "numeroAtualInterno",
        },
        {
          text: "Nº de pessoal EXTERNO disponível",
          value: "numeroAtualExterno",
        },
        {
          text: "Nº de pessoal INTERNO desejável",
          value: "numeroDesejavelInterno",
        },
        {
          text: "Nº de pessoal EXTERNO desejável",
          value: "numeroDesejavelExterno",
        },
        { text: "Ações", value: "acoes_delete", sortable: false },
      ],
      payload: [],
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadSalaUnidade() {
      this.setLoading(true);
      cargosFuncoes
        .list()
        .then((resp) => {
          this.payload = resp.data.filter((i) => {
            return i.municipioId === this.cityId;
          });
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter os dados");
        });
    },
  },
  mounted() {
    this.loadSalaUnidade();
  },
  computed: {
    ...mapGetters(["cityId"]),
  },
};
</script>
